module.exports = __webpack_public_path__ + "static/media/81mm.008d7e30.png";